import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataInput, IProjectConfig } from '../../../interface/interfaces';

interface IInitialState {
    projectFeatureListLoading: boolean;
    projectFeatureListData: IProjectConfig[];
    projectFeatureListError: string;
}

const initialState: IInitialState = {
    projectFeatureListLoading: false,
    projectFeatureListData: [],
    projectFeatureListError: '',
};

const projectFeatureListSlice = createSlice({
    name: 'projectFeatureList',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        projectFeatureListPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.projectFeatureListLoading = true;
            state.projectFeatureListError = '';
        },

        projectFeatureListFulfilled: (state: IInitialState, action: PayloadAction<IProjectConfig[]>) => {
            state.projectFeatureListLoading = false;
            state.projectFeatureListData = action.payload;
            state.projectFeatureListError = '';
        },

        projectFeatureListFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.projectFeatureListLoading = false;
            state.projectFeatureListData = [];
            state.projectFeatureListError = action.payload;
        },
    },
});

export default projectFeatureListSlice.reducer;
export const { projectFeatureListPending, projectFeatureListFulfilled, projectFeatureListFailure } = projectFeatureListSlice.actions;
